import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Stack as StackG, Text as TextG } from 'grommet'
import styled, { css } from 'styled-components'
import { setBoardIndex } from '../../redux/rng/actions'
import { useDarkMode } from '../../contextHook/darkMode'

const NumberBox = styled(Box)`
  border-radius: ${props => (!props.onFloating ? '20px' : '10px')};
  /* border: 1.5px solid ${props => props.theme.global.colors.border};
   */
  /* box-shadow: 0px 0px 2px 1px ${props =>
    props.theme.global.colors.border}; */
  height: ${props => (!props.onFloating ? '137px' : '87px')};
  background-color: ${props => props.theme.global.colors.inputDarkLight};
  margin: 0;
  @media (max-width: 550px) {
    height: 100px;
    border-radius: 15px;
  }

  /* width: 90px; */
`
const NumberCover = styled(Box)`
  border-radius: 5px;
  background-color: ${props =>
    props.selected
      ? props.toolColor
      : props.theme.global.colors.baseBackground};
  color: ${props =>
    props.selected
      ? props.theme.global.colors.invertTextStrong
      : props.theme.global.colors.text};
  height: ${props => (!props.onFloating ? '133px' : '85px')};
  /* box-shadow: 0px 0px 1px 1px ${props => props.theme.global.colors.dark}; */
  border: 1.5px solid
    ${props =>
      props.selected ? props.toolColor : props.theme.global.colors.border};
  margin-top: -2px;
  &:hover {
    /* border: 2px solid ${props => props.theme.global.colors.dark}; */
    box-shadow: ${props =>
      `0px 0px 0px 1px ${
        props.selected ? 'transparent' : props.theme.global.colors.border
      }`};
  }
  @media (max-width: 550px) {
    border-radius: 3px;
    height: 97.5px;
  }
`

const Text = styled(TextG)`
  color: inherit;
  text-align: center;
`

const TextInner = styled(TextG)`
  /* font-size: 64px; */
  font-size: ${props => (!props.onFloating ? '64px' : '50px')};
  @media (max-width: 550px) {
    font-size: 48px;
  }
`

const TextTop = styled(Text)`
  font-size: ${props => (!props.onFloating ? '28px' : '23px')};
  @media (max-width: 550px) {
    font-size: 22px;
  }
`

const TextBottom = styled(Text)`
  font-size: ${props => (!props.onFloating ? '19px' : '16px')};
  ${props =>
    props.onFloating &&
    css`
      line-height: 17px;
    `}
  @media (max-width: 550px) {
    font-size: 16px;
  }
`

const Stack = styled(StackG)`
  flex: 1 1 0px;
  width: 65px;

  max-width: ${props => (!props.onFloating ? '90px' : '65px')};
  @media (max-width: 550px) {
    max-width: 80px;
  }
  & > div {
    width: 100%;
  }
`

const NumberBoard = ({ object, index, onFloating, setDigitChoices }) => {
  const toolColorsPersist = useSelector(
    state => state.settings.wheelColors.colors,
  )
  const [toolColors, setToolColors] = useState(['', '', '', ''])
  const { value: darkMode } = useDarkMode()
  const dispatch = useDispatch()

  useEffect(() => {
    setToolColors(toolColorsPersist)
  }, [toolColorsPersist])
  return (
    <Stack onFloating={onFloating}>
      <NumberBox justify="center" align="center" onFloating={onFloating}>
        <TextInner
          weight="bold"
          color="invertTextStrong"
          onFloating={onFloating}
        >
          {object.result}
        </TextInner>
      </NumberBox>
      {object.result === null && (
        <NumberCover
          tabIndex="-1"
          justify="center"
          align="center"
          selected={object.selected}
          toolColor={toolColors[1]}
          onClick={() => {
            dispatch(setBoardIndex(index))
            setDigitChoices(index)
          }}
          onFloating={onFloating}
        >
          <TextTop weight="bold" onFloating={onFloating}>
            {object.numbering}
          </TextTop>
          <TextBottom onFloating={onFloating}>Num</TextBottom>
        </NumberCover>
      )}
    </Stack>
  )
}

export default NumberBoard
